/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommercePalletBase } from "./BigCommercePalletBase";
import {
  BigCommercePalletBaseFromJSON,
  BigCommercePalletBaseFromJSONTyped,
  BigCommercePalletBaseToJSON,
  BigCommercePalletBaseToJSONTyped,
} from "./BigCommercePalletBase";

/**
 *
 * @export
 * @interface BigCommercePalletization
 */
export interface BigCommercePalletization {
  /**
   *
   * @type {boolean}
   * @memberof BigCommercePalletization
   */
  enabled: boolean;
  /**
   *
   * @type {Array<BigCommercePalletBase>}
   * @memberof BigCommercePalletization
   */
  palletBases: Array<BigCommercePalletBase>;
  /**
   *
   * @type {number}
   * @memberof BigCommercePalletization
   */
  maxPalletHeightInches: number;
  /**
   *
   * @type {number}
   * @memberof BigCommercePalletization
   */
  maxPalletWeightPounds: number;
  /**
   *
   * @type {number}
   * @memberof BigCommercePalletization
   */
  palletTareWeightPounds: number;
  /**
   *
   * @type {boolean}
   * @memberof BigCommercePalletization
   */
  itemsStackOnEachOther: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BigCommercePalletization
   */
  palletsAreStackable: boolean;
}

/**
 * Check if a given object implements the BigCommercePalletization interface.
 */
export function instanceOfBigCommercePalletization(
  value: object,
): value is BigCommercePalletization {
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  if (!("palletBases" in value) || value["palletBases"] === undefined)
    return false;
  if (
    !("maxPalletHeightInches" in value) ||
    value["maxPalletHeightInches"] === undefined
  )
    return false;
  if (
    !("maxPalletWeightPounds" in value) ||
    value["maxPalletWeightPounds"] === undefined
  )
    return false;
  if (
    !("palletTareWeightPounds" in value) ||
    value["palletTareWeightPounds"] === undefined
  )
    return false;
  if (
    !("itemsStackOnEachOther" in value) ||
    value["itemsStackOnEachOther"] === undefined
  )
    return false;
  if (
    !("palletsAreStackable" in value) ||
    value["palletsAreStackable"] === undefined
  )
    return false;
  return true;
}

export function BigCommercePalletizationFromJSON(
  json: any,
): BigCommercePalletization {
  return BigCommercePalletizationFromJSONTyped(json, false);
}

export function BigCommercePalletizationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommercePalletization {
  if (json == null) {
    return json;
  }
  return {
    enabled: json["enabled"],
    palletBases: (json["palletBases"] as Array<any>).map(
      BigCommercePalletBaseFromJSON,
    ),
    maxPalletHeightInches: json["maxPalletHeightInches"],
    maxPalletWeightPounds: json["maxPalletWeightPounds"],
    palletTareWeightPounds: json["palletTareWeightPounds"],
    itemsStackOnEachOther: json["itemsStackOnEachOther"],
    palletsAreStackable: json["palletsAreStackable"],
  };
}

export function BigCommercePalletizationToJSON(
  json: any,
): BigCommercePalletization {
  return BigCommercePalletizationToJSONTyped(json, false);
}

export function BigCommercePalletizationToJSONTyped(
  value?: BigCommercePalletization | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enabled: value["enabled"],
    palletBases: (value["palletBases"] as Array<any>).map(
      BigCommercePalletBaseToJSON,
    ),
    maxPalletHeightInches: value["maxPalletHeightInches"],
    maxPalletWeightPounds: value["maxPalletWeightPounds"],
    palletTareWeightPounds: value["palletTareWeightPounds"],
    itemsStackOnEachOther: value["itemsStackOnEachOther"],
    palletsAreStackable: value["palletsAreStackable"],
  };
}
